

























































import {
  defineComponent,
  ref,
  computed,
  nextTick,
  PropType,
  watch,
} from '@vue/composition-api';
import type { ContractListItem } from '../type';
import { getContractIframeUrl, formatContractName } from '../utils';

export default defineComponent({
  name: 'ContractView',
  props: {
    /** 协议列表 */
    contractList: {
      type: Array as PropType<ContractListItem[]>,
      required: true,
      default: () => [],
    },
    /** 协议展示区域高度（单位：vm），默认自适应 */
    contractHeight: {
      type: Number,
      default: 0,
    },
    /** 初始选中的协议索引 */
    initialIndex: {
      type: Number,
      default: 0,
    },
  },
  emits: ['change-contract'],
  setup(props, { emit }) {
    const contractListRef = ref<HTMLDivElement | null>(null);
    const contractShowRef = ref<HTMLDivElement | null>(null);

    /** 当前选中的协议索引 */
    const activeContractIndex = ref(props.initialIndex);
    /** 协议列表是否超过最大高度（2行） */
    const isExceedMaxHeight = ref(false);
    /** 是否展开状态 */
    const isExpand = ref(false);

    /** 当前选中的协议 URL */
    const currentIframeUrl = computed(() => {
      if (!props.contractList || props.contractList.length === 0) {
        return '';
      }
      const currentContract = props.contractList[activeContractIndex.value];
      if (!currentContract) {
        return '';
      }
      const url = currentContract.url || '';
      return getContractIframeUrl(url, currentContract.type);
    });

    /**
     * 切换协议
     * @param index 协议索引
     */
    const onChangeContract = (index: number) => {
      if (index === activeContractIndex.value) {
        return;
      }
      activeContractIndex.value = index;
      const currentContract = props.contractList[index];
      emit('change-contract', {
        index,
        contract: currentContract,
      });
    };

    /**
     * 切换展开/收起状态
     */
    const toggleExpand = () => {
      isExpand.value = !isExpand.value;
      if (contractListRef.value) {
        contractListRef.value.scrollTo(0, 0);
      }
    };

    /**
     * 计算协议名称列表是否超过最大高度
     */
    const calcContractNameHeight = () => {
      if (contractListRef.value) {
        const element = contractListRef.value;
        // 滚动高度 > 容器可见高度 → 超过最大高度
        if ((element.scrollHeight - element.clientHeight) >= 5) {
          isExceedMaxHeight.value = true;
        }
      }
    };

    watch(() => props.contractList, (newValue, oldValue) => {
      if (oldValue && newValue && oldValue.length !== newValue.length) {
        nextTick(() => {
          calcContractNameHeight();
        });
      }
    }, { immediate: true, deep: true });

    return {
      contractListRef,
      contractShowRef,
      activeContractIndex,
      isExceedMaxHeight,
      isExpand,
      currentIframeUrl,
      onChangeContract,
      toggleExpand,
      formatContractName,
    };
  },
});
